module.exports = "/images/Ecuador.png?843f2ef6e3b43a8630c779c455002649";